import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 🚀 1. เช็คข้อมูลจากทั้ง 2 แหล่ง (เปลี่ยนคีย์ใหม่เพื่อเคลียร์บั๊กค้างในเบราว์เซอร์)
    const storedUser = localStorage.getItem('thunder_crm_user') || sessionStorage.getItem('thunder_crm_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  // 🚀 2. เพิ่มพารามิเตอร์ rememberMe เข้ามา
  const login = (userData, rememberMe = false) => {
    setUser(userData);
    if (rememberMe) {
      // ถ้าติ๊ก "จำไอดี" ให้เซฟลง localStorage (อยู่ถาวรจนกว่าจะกดออก)
      localStorage.setItem('thunder_crm_user', JSON.stringify(userData));
    } else {
      // ถ้าไม่ติ๊ก ให้เซฟลง sessionStorage (ปิดแท็บ/ปิดเบราว์เซอร์ปุ๊บ ข้อมูลหายทันที ปลอดภัย!)
      sessionStorage.setItem('thunder_crm_user', JSON.stringify(userData));
    }
  };

  const logout = () => {
    // 🚀 3. ล้างค่าทั้งหมด แต่ "ไม่ใส่โค้ดเปลี่ยนหน้าตรงนี้"
    // ปล่อยให้ <AdminProtectedRoute> ใน App.js เป็นคนเตะแอดมินกลับไปหน้า Login เอง!
    setUser(null);
    localStorage.removeItem('thunder_crm_user');
    sessionStorage.removeItem('thunder_crm_user');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);